import { render } from "./recruitment-journey-workflow.vue?vue&type=template&id=875c2a44&scoped=true"
import script from "./recruitment-journey-workflow.vue?vue&type=script&lang=js"
export * from "./recruitment-journey-workflow.vue?vue&type=script&lang=js"

import "./recruitment-journey-workflow.vue?vue&type=style&index=0&id=875c2a44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-875c2a44"

export default script